import { DefaultTheme } from "styled-components";

const mainTheme: DefaultTheme = {
  name: "default",
  colors: {
    text1: "#000",
    secondaryText1: "#000",

    bg1: "FFF",

    primary1: "#A560B0",

    danger: "#e53e3e",
  },
};

export { mainTheme };
